import React from "react";

/**
 * Branded park cover: operator brand colour + their logo + park name.
 * Used as the main thumbnail across ParkCard, Deals and Compare so users
 * immediately recognise which brand a park belongs to.
 */
export default function OperatorCover({ park, size = "md", className = "" }) {
  const bg = park.operator_color || "#2C5545";
  const fg = park.operator_text_color || "#FFFFFF";
  const isSmall = size === "sm";

  return (
    <div
      className={`relative w-full h-full flex flex-col items-center justify-center ${className}`}
      style={{ background: `linear-gradient(135deg, ${bg} 0%, ${shade(bg, -12)} 100%)`, color: fg }}
      data-testid={`operator-cover-${park.slug}`}
    >
      {/* Subtle pattern overlay for visual texture */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `radial-gradient(circle at 20% 20%, rgba(255,255,255,0.4) 0, transparent 40%), radial-gradient(circle at 80% 80%, rgba(0,0,0,0.2) 0, transparent 50%)`,
        }}
      />
      <div className="relative z-10 flex flex-col items-center text-center px-4">
        {park.operator_logo && (
          <div className={`bg-white rounded-full flex items-center justify-center shadow-lg ${isSmall ? "w-10 h-10" : "w-16 h-16"}`}>
            <img
              src={park.operator_logo}
              alt={park.operator}
              className={isSmall ? "w-6 h-6 object-contain" : "w-10 h-10 object-contain"}
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          </div>
        )}
        <div
          className={`font-display font-extrabold tracking-tight mt-2 ${isSmall ? "text-base" : "text-2xl"}`}
          style={{ color: fg }}
        >
          {park.operator}
        </div>
        {!isSmall && (
          <div className="text-xs uppercase tracking-[0.18em] font-semibold mt-1 opacity-80" style={{ color: fg }}>
            {park.region}
          </div>
        )}
      </div>
    </div>
  );
}

// Lighten/darken a hex colour by N % (positive = lighter)
function shade(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) + percent;
  let g = ((num >> 8) & 0xff) + percent;
  let b = (num & 0xff) + percent;
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  return "#" + ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0");
}
